class FunnelResultVM extends BaseResultVM {
    static readonly xArgument = "xArgument";

    dataTable: any[];
    field: FunnelColumnInfo;
    descriptionField: FunnelColumnInfo;
    metric: FunnelColumnInfo;
    repaint: Function;

    currencyCode: string;

    funnelSettings: DevExpress.viz.dxFunnel.Properties;

    constructor(data) {
        super(data);

        this.dataTable = data.dataTable ?? [];
        this.field = data.field;
        this.descriptionField = data.descriptionField;
        this.metric = data.metric;

        this.currencyCode = data.currencyCode;
        if (this.dataTable && this.field) {
            for (let row of this.dataTable) {
                let value = row[this.field.index];
                row[FunnelResultVM.xArgument] = value === null ? irSettings.nullText : value;
                if (this.field.autoGrouping != AutoGroupingEnum.None) {
                    let output = getAutoGroupingText(value, this.field.autoGrouping);
                    row[FunnelResultVM.xArgument] = `${output}`;
                }
            }
        }
    }
}

class FunnelColumnInfo {
    index: number;
    queryName: string;
    autoGrouping: AutoGroupingEnum;
    groupingType: GroupingTypeEnum;
    dataType: DataTypeEnum;

    accountingStyle: boolean;
    decimalPlaces: number;
    metricFormat: FieldFormatEnum;
}